const CONSTANTS = require("./metadata");

const RULES = CONSTANTS.RULES

function getRule(playerCount, groupSize) {

  var howManyLeave = playerCount % groupSize;
  var howManyStay = groupSize - howManyLeave;

  // player ocunt within bounds
  if ((playerCount < (groupSize) || playerCount > (groupSize * 2) || groupSize === '-')) {
    return {"rule": RULES["5"], "ruleId": "5", "raceCount": '-', "groupSize": groupSize, "playerCount": '-'};
  // rules algo not made for > 8 players
  } else if (playerCount > 8) {
    return {"rule": RULES["6"], "ruleId": "6", "raceCount": 0, "groupSize": 0, "playerCount": playerCount}
  } else if (howManyStay === playerCount) {
    return {"rule": RULES["0"], "ruleId": "0", "raceCount": 16, "groupSize": groupSize, "playerCount": playerCount}
  } else if (howManyStay === 1) {
    return {"rule": RULES["1"], "ruleId": "1", "raceCount": 18, "groupSize": groupSize, "playerCount": playerCount}
  } else if (howManyStay === 2 && howManyStay !== groupSize) {
    return {"rule": RULES["2"], "ruleId": "2", "raceCount": 18, "groupSize": groupSize, "playerCount": playerCount}
  } else if (howManyStay === 3 && howManyStay !== groupSize) {
    return {"rule": RULES["3"], "ruleId": "3", "raceCount": 18, "groupSize": groupSize, "playerCount": playerCount}
  } else if (howManyStay === groupSize && groupSize <= playerCount) {
    return {"rule": RULES["4"], "ruleId": "4", "raceCount": 18, "groupSize": groupSize, "playerCount": playerCount}
  }
}

function getAllowedGroupSizes(count) {
  let allowedSizes = [];

  if (count < 2) {
    allowedSizes = [];
  } else if (count <= 3) {
    allowedSizes = [2, 3].slice(0, count - 1);
  } else if (count <= 4) {
    allowedSizes = [2, 3, 4];
  } else if (count <= 6) {
    allowedSizes = [3, 4];
  } else {
    allowedSizes = [4];
  }

  return allowedSizes;
}


module.exports.getRule = getRule;
module.exports.getAllowedGroupSizes = getAllowedGroupSizes;
